var fowtr_module_tutorial = (function (fowtr_module_tutorial) {
    var fullScreenHasShown = false;
    var part2ReleaseHasShown = false;

    fowtr_module_tutorial.init = function(chapter){



      // part 2 release nag popup
      if(chapter==1 || chapter==2) {
        if(!part2ReleaseHasShown){

          var popupTimeout = 8;
          TweenMax.set($('#fowtr-tutorial .fowtr-tutorial-part-2-release'),{css:{display:'block'},delay:0.8});
          TweenMax.fromTo($('#fowtr-tutorial .fowtr-tutorial-part-2-release'),1,{y:"+=50px",autoAlpha:0},{y:0,autoAlpha:1, ease:Power4.easeOut,delay:0.8});
          TweenMax.fromTo($('#fowtr-tutorial .fowtr-tutorial-part-2-release .timeout'),popupTimeout,{scaleX:1},{scaleX:0, ease:Linear.easeNone,delay:0.8, onComplete:hidePart2ReleasePopup});

          function hidePart2ReleasePopup(){
            $('#fowtr-tutorial .fowtr-tutorial-part-2-release').fadeOut();
            part2ReleaseHasShown = true;
          }

          $('#fowtr-wrapper').on('click', '#fowtr-tutorial .fowtr-tutorial-part2-release-close, #fowtr-navigation .fowtr-hamburger-menu', function(event) {
            event.preventDefault();
            hidePart2ReleasePopup();
          });

          part2ReleaseHasShown = true;
        }
      }




      // fullscreen nag popup

      // console.log('fowtr_module_tutorial initialised chapter '+chapter);
      // if(chapter!=1) return;
      if(!fullScreenHasShown && $(window).width()>1365){

        var popupTimeout = 8;
        TweenMax.set($('#fowtr-tutorial .fowtr-tutorial-fullscreen'),{css:{display:'block'},delay:1});
        TweenMax.fromTo($('#fowtr-tutorial .fowtr-tutorial-fullscreen'),1,{y:"+=50px",autoAlpha:0},{y:0,autoAlpha:1, ease:Power4.easeOut,delay:1});
        TweenMax.fromTo($('#fowtr-tutorial .fowtr-tutorial-fullscreen .timeout'),popupTimeout,{scaleX:1},{scaleX:0, ease:Linear.easeNone,delay:1, onComplete:hideFullScreenPopup});
        // setTimeout(function(){
        //   $('#fowtr-tutorial .fowtr-tutorial-fullscreen').fadeOut();
        // }, 8000);
        function hideFullScreenPopup(){
          $('#fowtr-tutorial .fowtr-tutorial-fullscreen').fadeOut();
          fullScreenHasShown = true;
        }
        // ============================================================================================
        // TUTORIAL SVG ANIMATION
        // ============================================================================================

        var tl = new TimelineMax({repeat:-1,delay:2});
        tl.set($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #bottom'), {transformOrigin:'bottom'});
        tl.set($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #middle'), {transformOrigin:'center'});
        tl.fromTo($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #top'), 2, {autoAlpha:1},{autoAlpha:0,scaleY:0,ease:Power4.easeInOut},0);
        tl.fromTo($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #middle'), 2, {scaleX:1,scaleY:1},{scaleX:1.9,scaleY:1.46,ease:Power4.easeInOut},0);
        tl.fromTo($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #bottom'), 2, {autoAlpha:1},{autoAlpha:0,scaleY:0,ease:Power4.easeInOut},0);

        //reverse
        tl.to($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #top'), 0.5, {autoAlpha:1,scaleY:1,ease:Power4.easeInOut},3);
        tl.to($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #middle'), 0.5, {scaleX:1,scaleY:1,ease:Power4.easeInOut},3);
        tl.to($('#fowtr-tutorial .fowtr-tutorial-fullscreen svg #bottom'), 0.5, {autoAlpha:1,scaleY:1,ease:Power4.easeInOut},3);

        //fade
        // tl.to($('.fowtr-tutorial-fullscreen svg #middle'), 0.5, {autoAlpha:0,ease:Power4.easeInOut},3);

        // tl.set($('.fowtr-tutorial-fullscreen svg #top'), {scaleX:1,scaleY:1,autoAlpha:0,ease:Power4.easeInOut},3.5);
        // tl.set($('.fowtr-tutorial-fullscreen svg #middle'), {scaleX:1,scaleY:1,autoAlpha:0,ease:Power4.easeInOut},3.5);
        // tl.set($('.fowtr-tutorial-fullscreen svg #bottom'), {scaleX:1,scaleY:1,autoAlpha:0,ease:Power4.easeInOut},3.5);

        // tl.to($('.fowtr-tutorial-fullscreen svg #top'), 0.5, {autoAlpha:1,ease:Power4.easeInOut},3.5);
        // tl.to($('.fowtr-tutorial-fullscreen svg #middle'), 0.5, {autoAlpha:1,ease:Power4.easeInOut},3.5);
        // tl.to($('.fowtr-tutorial-fullscreen svg #bottom'), 0.5, {autoAlpha:1,ease:Power4.easeInOut},3.5);

        $('#fowtr-wrapper').on('click', '#fowtr-tutorial .fowtr-tutorial-fullscreen-close', function(event) {
          event.preventDefault();
          hideFullScreenPopup();
        });

        fullScreenHasShown = true;




        //don't show if already full width
        // $(window).on('resize', function(){
        //   if($(window).width()<1365){

        //   }
        // });

      }
    };

    return fowtr_module_tutorial;
}(fowtr_module_tutorial || {}));
